// extracted by mini-css-extract-plugin
export default {"logoutBtn":"style_logoutBtn__hCNZR","icon":"style_icon__9CxMy"};